<template>
    <form class="dd-m-form dd-m-search" id="searchform" v-on:submit.prevent="doSearch()" autocomplete="off" :class="appendclass">
        <div class="dd-m-form__icon-input dd-m-form__icon-input--dark" :class="{focused}">
            <v-autocomplete
                    :placeholder="getTranslateString('Which AVON fragrances are you looking for?')"
                    :items="options"
                    :min-len="1"
                    v-model="search"
                    :get-label="getLabel"
                    :auto-select-one-item="false"
                    :component-item="template"
                    input-class="dd-search-value dd-m-search__input"
                    @item-selected="itemSelected"
                    @update-items="updateItems"
                    @focus="focused = true"
                    @blur="focused = false">
            </v-autocomplete>
            <button
                    @click="doSearch()"
                    class="dd-m-button dd-m-button--dark dd-m-button--tiny dd-m-helper--centralize">
                <i class="dd-m-icon icon-search"></i>
            </button>
        </div>
    </form>
</template>
<script>
    import ItemTemplate from "./search/itemTemplate";
    import SearchService from "../providers/api/search-service";
    import ProductService from "../providers/api/product-service";

    const searchService = new SearchService(),
        productService = new ProductService(),
        debounce = require("debounce");

    export default {
        name: "search-form",
        props: ['appendclass'],
        data() {
            return {
                template: ItemTemplate,
                search: null,
                options: [],
                hasLoaded: false,
                params: {
                    term: "",
                    page: 1,
                    perPage: 5
                },
                focused: false,
            };
        },
        mounted() {
            this.options = searchService.getTermsArray().reverse();
            this.watchEnter();
        },
        methods: {
            watchEnter() {
                $(".dd-search-value").keypress(event => {
                    const keycode = event.keyCode ? event.keyCode : event.which;
                    if (keycode == "13") {
                        setTimeout(() => {
                            this.doSearch();
                        }, 500);
                    }
                });
            },
            getLabel(item) {
                if (!item) return;
                return item.name;
            },
            updateItems(text) {
                this.params.term = text;

                productService
                    .doSearch(this.params)
                    .then(res => (this.options = res.data.data));
            },
            itemSelected(item) {
                if (!item.name) return;
                this.doSearch(item.name);
            },
            doSearch(text) {
                const val = text ? text : $(`.${this.appendclass} .dd-search-value`).val();
                if (!val) return;

                let url = `/busca?search=${val}`;

                if (language !== 'en') {
                    url = `/${language}/busca?search=${val}`;
                }

                location.href = url;
                searchService.doSaveTerm(val);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/site/js/components/search-form.vue